import { useCallback } from 'react';

import { saveAs } from 'file-saver';
import { getFontEmbedCSS, toPng } from 'html-to-image';

import type { Options } from 'html-to-image/src/types';

const useScreenshot = () => {
    const generatePng = useCallback(
        async (ref: HTMLElement, name: string, options: Options = {}) => {
            if (ref === null) {
                return;
            }
            try {
                // Font embedding may fail due to CORS - attempt but continue without it
                let fontEmbedCSS: string | undefined;
                try {
                    fontEmbedCSS = await getFontEmbedCSS(ref);
                } catch {
                    // Font embedding failed (likely CORS) - continue without embedded fonts
                }

                const screenShot = await toPng(ref, {
                    ...options,
                    fontEmbedCSS,
                    includeQueryParams: true
                });
                saveAs(screenShot, `${name ?? 'export'}.png`);
            } catch {
                // Screenshot generation failed - silently fail as it's not critical
            }
        },
        []
    );

    return { generatePng };
};

export default useScreenshot;
